import React from 'react';
import MAP from '../data/emoji3d.json';

/* Premium 3D art (Microsoft Fluent Emoji 3D, MIT) for a game emoji; falls back to the text emoji. */
export const EmojiArt = ({ emoji, size = 64, glow = false, style }) => {
  const file = MAP[emoji];
  if (!file) return <span style={{ fontSize: typeof size === 'number' ? size * 0.9 : 'clamp(30px, 10vw, 60px)', lineHeight: 1, ...style }}>{emoji}</span>;
  return (
    <img src={`${process.env.PUBLIC_URL || ''}/emoji3d/${file}.webp`} alt={emoji} draggable={false}
      loading="lazy" decoding="async" data-testid="emoji-art"
      style={{ width: size, height: size, objectFit: 'contain', userSelect: 'none', pointerEvents: 'none',
        filter: glow
          ? 'drop-shadow(0 0 10px rgba(255,216,107,0.85)) drop-shadow(0 4px 6px rgba(0,0,0,0.6))'
          : 'drop-shadow(0 0 4px rgba(212,175,55,0.35)) drop-shadow(0 4px 6px rgba(0,0,0,0.55))',
        ...style }}/>
  );
};

export default EmojiArt;
